var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 435 435",
    viewBox: "0 0 435 435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eebea7",
    d: "M346.5 407c-5.9-9.8-10.6-12.4-25.2-12.8-14.6-.4-34-.2-34-.2l-.2 20.7s16.1 9.3 24.7 13.9c.5.3 1.9 1.1 2.9 1.7 1.5.7 3.1 1.3 4.7 1.7 8.5 1.8 16.2.9 21.7-4.6 6.1-6.1 11.3-10.6 5.4-20.4zM236.4 388.6c-.5.4-1.8 1.4-2.7 2.1-1.2 1.1-2.3 2.4-3.3 3.7-4.8 7.2-6.9 14.7-3.8 21.9 3.4 7.9 5.7 14.5 16.9 12.6 11.2-1.9 15.5-5.3 21.3-18.6 5.8-13.3 12.9-31.5 12.8-31.5l-19.1-7.9s-14.6 11.5-22.1 17.7z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1142.934,
    x2: 829.39,
    y1: -368.016,
    y2: -368.016,
    gradientTransform: "matrix(1 0 0 -1 -707.48 3.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25B39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538bd6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M288.6 394.9s.3 20.9-3.1 21.4-50.3-6.3-69-7.3-61.1-13.1-81.9-36.6c-18-20.3-15.2-42.8-1.9-42.8s25.5-11.3 59.3 4.8 69.6 18.8 89.7 17.2 76.4-12 80.8-15.2 25.5-12.4 54.9-9.2 15.5 26.5 9.3 35.5c-8.7 12.5-29.3 25.9-46.5 26.5s-91.6 5.7-91.6 5.7z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 228,
    x2: 402.901,
    y1: 149.249,
    y2: 149.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eebea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c51"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M253.8 29.4C243.9 33 231.3 82 231.3 82l-.2-.2-1.4 6.8-1.7 8.9 3.3 53.2 32 16 73.5 19.8 20.3 28.9s45.5 46.3 45.8 49.5-48.9 19.5-53.6 20.2c-11.3 1.7 72.3-18.8 45.5-51.3-11.4-13.9-28.1-55.7-61.2-83.4-19.2-16-13.8-61.5-20.6-90.3-8.5-36-13.7-46.8-22.2-46.8-7.7 0-18.4 9.2-37 16.1"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 153.784,
    x2: 419.901,
    y1: 441.174,
    y2: 441.174,
    gradientTransform: "matrix(1 0 0 -1 0 672)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb9678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9678"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M357.8 145.7c-15.4-14.1-20.6-17.5-34.1-12.7s-20.1 9.2-38.5 12.2c-11.3 2-23 .5-33.5-4.1l-37.9 3.8c-4.8-.6-58.7 100.6-60 121.6-.8 12.9 28.5 32.8 36.7 34.8 3.3.8 9.2-31 11.1-33.9l-12.3-3.8c2.2-5.5 9.6-19.1 14.5-26.4 1.5-2.3 13.2-21.6 14.8-29 .3.7 2 14.7 3.6 19.2 3 8.3 7.1 13 7.1 19.6s-.8 32.8-5.6 44.6-11.8 39.1-11.8 39.1l121.2-.7s-4.4-52.1-2.6-70c0 0-1.9-7.2 1.7-17.6 5.9-17.2 7.6-42.8 6.6-46.8-1.5-6.3 35.6 47 43.7 60.5 3.4 5.6-42.7 15.5-46.5 19.8-4 4.5 3.9 16.7 3.9 16.7s80.4-9.8 80-22.1c-.4-12.3-44.2-108.5-62.1-124.8z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 207.1,
    x2: 357.018,
    y1: 554.212,
    y2: 554.212,
    gradientTransform: "matrix(1 0 0 -1 0 672)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#254368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e538c"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M263.5.6s-22.5.9-29 24.5-7.4 56.5-7.6 61.6c-.2 5.4 2.3 37-9.8 50.2-10.4 11.4-6.2 22.4-8.8 31.5l-1.2 15.1c.2 1.8 1.5 3.3 3.2 3.9 1.6.5 7.2-2.1 8.2-2.5 14-5.6 14-10.1 19.3-14.6 4.4-3.7 16.5-12.3 20.1-15.7s6.1-6.4 6.3-10.7c.7-21.9-3.1-42.1-7.9-52.8s-14-28.8-6.3-40.8 21.6-24 22.4-27 1.2 11.6 9.7 16.7 15.6 12.2 18.2 19.1c2.2 5.8 5.1 15.7-2.9 32.8s-14.5 39.1-3.2 55.4 35.1 33.9 39 42.1c4.4 9.1.2 30.5-.6 43.4s25.2-22.4 24.4-39.2 2-24-14.1-49.8-26.6-70-27-80.7-5.2-40.4-14.9-48.9C292.6 7 290.8 0 273.6 0c-3.4 0-6.8.2-10.1.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m212.2 358.2 113.6.6s-13.3 10.4-19.7 11.6-33.8 14.8-44 9.6c-7.2-3.9-49.9-21.8-49.9-21.8zM275.5 103.1s10.6 2.7 15-3.5c9.9-14 .9 7.1.9 7.1s-2.9 8.2-2.7 12.3-11.4-15.3-13.2-15.9M233.1 175.1c-1.3 1.6-3.2 2.9-4.2 7-1.7 6.6-3.5 14-8.1 20.8-2.7 4-1.2 19.5 3.3 29.3 1.3 2.8 5.3 10.1 5.2 11.8l-.3 14.2h12.2s10.4 1.1 8.2-7.5c-1.9-7.6-11.8-35.9-5.1-42.1 12.6-11.5-3.3-34.5 2.6-41.9 5.1-6.4 12.4-11 12.4-13.1 0-.8-1.9 1.8-3.2 2.7-2.5 1.8-3.8 3.2-5.9 4.6-2.3 1.5-5.8 4-8.1 5.7-3.3 2.5-6.3 5.3-9 8.5z",
    enableBackground: "new",
    opacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M185.6 266.2s-.1-7.4 7.2-7.7 161.9-.1 161.9-.1 6.8.8 7 6.3.2 87.2.2 87.2.1 6.3-6.6 6.5-164.3.2-164.3.2-5.9-1.5-5.8-7.4.4-85 .4-85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 280.9,
    x2: 267.54,
    y1: -44.5,
    y2: -44.5,
    gradientTransform: "matrix(1 0 0 -1 0 264)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25B39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25B39E"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 274.2,
    cy: 308.5,
    r: 6.7,
    fill: "url(#e)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.d935cf3551647f638badd7f17af5cf16.svg";
export { ForwardRef as ReactComponent };